// extracted by mini-css-extract-plugin
export default {"container":"hawk-spinner-container","overlay":"hawk-spinner-overlay","main":"hawk-spinner-main","spin":"hawk-spinner-spin"};